import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { apiService } from '../../components/Config/api.service';
import { BOUTON_SECONDAIRE, enveloppeDe } from '../Employee/organigrammeOutils';
import { CARTE } from './departOutils';

/**
 * Les domiciliations de salaire du salarié qui part (contrat C35,
 * Yros/Kavero#435, #62). Une fois le départ lancé, « Prévenir la banque »
 * envoie à la banque un e-mail sans aucun montant et lève la domiciliation ;
 * la date de l'envoi reste affichée. Elles se saisissent sur la fiche du
 * salarié.
 */
const ETATS_PREVENIR = ['lance', 'stc_valide'];

function DepartDomiciliations({ depart, onDepart }) {
  const { t } = useTranslation();
  const [enCours, setEnCours] = useState(null);
  const [erreur, setErreur] = useState('');
  const domiciliations = depart.domiciliations || [];
  const peutPrevenir = ETATS_PREVENIR.includes(depart.etat);

  const prevenir = async (domiciliation) => {
    if (!window.confirm(t('departs.domiciliations.confirmer', { banque: domiciliation.banque }))) return;
    setEnCours(domiciliation.id);
    setErreur('');
    const reponse = await enveloppeDe(() => apiService.prevenirBanque(depart.id, domiciliation.id));
    setEnCours(null);
    if (reponse.ok) onDepart(reponse.depart);
    else setErreur(reponse.message || t('departs.erreurGenerique'));
  };

  return (
    <div className={CARTE} data-testid="depart-domiciliations">
      <h2 className="text-base font-semibold mb-3">{t('departs.domiciliations.titre')}</h2>
      {domiciliations.length === 0 ? (
        <p className="text-sm text-gray-500">{t('departs.domiciliations.aucune')}</p>
      ) : (
        <ul className="divide-y text-sm">
          {domiciliations.map((domiciliation) => (
            <li key={domiciliation.id} className="py-2 flex flex-wrap items-center justify-between gap-3"
              data-testid={`depart-domiciliation-${domiciliation.id}`}>
              <div>
                <p className="font-medium">{domiciliation.banque}</p>
                <p className="text-gray-500">{domiciliation.email_banque}</p>
              </div>
              {domiciliation.etat === 'active' ? (
                peutPrevenir && (
                  <button type="button" data-testid={`depart-prevenir-${domiciliation.id}`}
                    disabled={enCours !== null} className={BOUTON_SECONDAIRE} onClick={() => prevenir(domiciliation)}>
                    {t('departs.domiciliations.prevenir')}
                  </button>
                )
              ) : (
                <span className="text-gray-600">
                  {domiciliation.prevenue_le
                    ? t('departs.domiciliations.prevenue', { date: domiciliation.prevenue_le.slice(0, 10) })
                    : t('departs.domiciliations.levee')}
                </span>
              )}
            </li>
          ))}
        </ul>
      )}
      {erreur && <p role="alert" className="mt-2 text-sm text-red-700">{erreur}</p>}
    </div>
  );
}

export default DepartDomiciliations;
